import { alpha, type Theme } from "@mui/material/styles";

import type { IconButtonSize, IconButtonTone, IconButtonVariant } from "./types";

// ============================================================================
// Tokens de tamanho
// ============================================================================

export const SIZE_TOKENS: Record<
  IconButtonSize,
  { side: number; iconFontSize: number; spinner: number }
> = {
  sm: { side: 32, iconFontSize: 16, spinner: 14 },
  md: { side: 40, iconFontSize: 20, spinner: 18 },
  lg: { side: 48, iconFontSize: 24, spinner: 22 },
};

export const DEFAULT_TONE: IconButtonTone = "neutral";
export const DEFAULT_VARIANT: IconButtonVariant = "ghost";
export const DEFAULT_SIZE: IconButtonSize = "md";

// ============================================================================
// Paleta por tom
// ============================================================================

/** Cor-base de cada tom. Os fundos (alpha) derivam dela em `resolveTonePalette`. */
function toneColor(theme: Theme, tone: IconButtonTone): string {
  switch (tone) {
    case "brand":
      return theme.palette.primary.main;
    case "success":
      return theme.palette.success.main;
    case "warning":
      return theme.palette.warning.main;
    case "danger":
      return theme.palette.error.main;
    case "neutral":
    default:
      return theme.palette.grey[300];
  }
}

export type TonePalette = { base: string; bg: string; bgHover: string; bgActive: string };

export function resolveTonePalette(theme: Theme, tone: IconButtonTone): TonePalette {
  const base = toneColor(theme, tone);
  return {
    base,
    bg: alpha(base, 0.1),
    bgHover: alpha(base, 0.18),
    bgActive: alpha(base, 0.26),
  };
}
